import React from "react";

// Make sure Font Awesome CSS is loaded in your index.html or main layout!

const Preloader = ({ message = "Loading..." }) => (
  <div className="d-flex flex-column align-items-center justify-content-center py-5" style={{ minHeight: "300px" }}>
    <i
      className="fas fa-microscope fa-4x text-dark mb-3"
      style={{
        animation: "microscope-spin 1.2s linear infinite"
      }}
    ></i>
    <style>
      {`
        @keyframes microscope-spin {
          0% { transform: rotate(-10deg);}
          50% { transform: rotate(10deg);}
          100% { transform: rotate(-10deg);}
        }
      `}
    </style>
    <div className="text-dark fw-bold">{message}</div>
  </div>
);

export default Preloader;